import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {CdkDragEnd} from '@angular/cdk/drag-drop';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import {FontProperty} from '../../../model/FontProperty';
import {ImageProperty} from '../../../model/ImageProperty';
import {ElementHtml} from '../../../../global/util/ElementHtml';
import {Dialog} from '../../../../global/util/Dialog';
import {InformType} from '../../../../global/util/enum/InformType';
import {Template} from '../../../model/Template';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {TemplateService} from '../../../service/template.service';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {TranslateService} from '@ngx-translate/core';
import {Constant} from '../../../../global/util/Constant';
import {PreviewTemplateComponent} from '../preview-template/preview-template.component';
import {MoreAboutTemplate} from '../../../model/common/MoreAboutTemplate';
import {Element} from '../../../model/others/Element';
import {Row} from '../../../model/others/Row';
import {Column} from '../../../model/others/Column';
import {Cell} from '../../../model/others/Cell';
import {TableProperty} from '../../../model/TableProperty';
import {HttpEvent, HttpEventType} from '@angular/common/http';
import {AuthService} from '../../../service/auth/auth.service';
import {SessionStorage} from '../../../../global/util/SessionStorage';
import {EnterpriseDataService} from '../../../service/data/enterprise-data.service';

@Component({
  selector: 'app-add-edit-template',
  templateUrl: './add-edit-template.component.html',
  styleUrls: ['./add-edit-template.component.css']
})
export class AddEditTemplateComponent implements OnInit, AfterViewInit {
  public template: Template;
  public templateForm: FormGroup;
  public loading: any;
  // Dentro de la pdfContainer se declarará el contenedor del PDF.
  @ViewChild('pdfContainer') pdfContainer: ElementRef | any;
  private rows: any[] = [];
  private columns: any[] = [];
  public elements: Array<any>;
  public type: any;
  public content: any;
  public index: any;
  // Aquí se establece el tamaño inicial que va tener el PDF
  private jsPDF = new jsPDF('p', 'pt', 'letter');
  private elementType: number;
  public isAddTable: boolean;
  private width = 'max-content';
  private height = 'max-content';
  public partnerIdSelected = 1;
  public enterpriseIdSelected = 1;
  public selectImageItem: boolean;
  public selectFontItem: boolean;
  public selectTableItem: boolean;
  public imageProperty = new ImageProperty();
  public fontProperty = new FontProperty();
  public tableProperty = new TableProperty();
  private elementHtmlSelected: any;
  public elementSelected: any;
  public TEXT_TYPE = ElementHtml.TYPE_TEXT;
  public IMAGE_TYPE = ElementHtml.TYPE_IMG;
  public TABLE_TYPE = ElementHtml.TYPE_TABLE;
  public PARAM_TYPE = ElementHtml.TYPE_PARAM;
  public TEXT_DESCRIPTION = ElementHtml.TEXT_DESCRIPTION;
  public PARAM_DESCRIPTION = ElementHtml.PARAM_DESCRIPTION;
  public NONE = ElementHtml.NONE;
  public TD = ElementHtml.TD;
  public TH = ElementHtml.TH;
  public cells: any[] = [];
  public designTemplate: boolean;
  public selectedFile: any;
  public progressUpdate: any;
  public uploading: boolean;
  public partners: any[] = [];
  public enterprises: any[] = [];
  public ROLE_SUPERADMIN = Constant.ROLE_SUPERADMIN;
  public ROLE_PARTNER = Constant.ROLE_PARTNER;
  public showAll = false;
  public parameters: any[] = [];
  pdfSrc: any;

  constructor(public activeModal: NgbActiveModal,
              private modalService: NgbModal,
              private formBuilder: FormBuilder,
              private templateService: TemplateService,
              private translate: TranslateService,
              private enterpriseDataService: EnterpriseDataService,
              private authenticationService: AuthService) {
    this.createForm();
    this.jsPDF.setFontSize(12);
  }

  ngOnInit(): void {
    this.type = 1;
    this.setDefaultData();
    this.loadDataTemplate();
  }

  ngAfterViewInit(): void {
    this.getDefaultData();
  }

  save() {
    if (this.templateForm.invalid) {
      Object.values(this.templateForm.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }
    this.loading = true;
    this.isNewTemplate ? this.register() : this.edit();
  }

  cancel() {
    this.activeModal.close();
  }

  change(type: number) {
    return this.type = type;
  }

  // Se obtiene estilos del elemento HTML luego se establece en la clase fontProperty
  addFontProperties(elementSelected: any, index?: number, type?: string, indexColumn?: number, indexRow?: number, indexCell?: number) {
    this.selectImageItem = false;
    this.selectTableItem = false;
    this.fontProperty = new FontProperty();
    const elementCopy = Object.assign(elementSelected, {});
    this.elementHtmlSelected = this.getElementBy(index, type, indexColumn, indexRow, indexCell);
    this.fontProperty.indexElement = index;
    this.fontProperty.elementType = type;
    this.fontProperty.borderRadius = '5px';
    this.fontProperty.fontFamily = this.elementHtmlSelected.style.fontFamily ? this.elementHtmlSelected.style.fontFamily : 'Helvetica';
    this.fontProperty.fontSize = this.elementHtmlSelected.style.fontSize ? this.elementHtmlSelected.style.fontSize : '12px';
    this.fontProperty.fontWeight = this.elementHtmlSelected.style.fontWeight ? this.elementHtmlSelected.style.fontWeight : 'normal';
    this.fontProperty.textDecoration = this.elementHtmlSelected.style.textDecoration ? this.elementHtmlSelected.style.textDecoration : 'none';
    this.fontProperty.textAlign = this.elementHtmlSelected.style.textAlign ? this.elementHtmlSelected.style.textAlign : 'left';
    this.fontProperty.color = this.elementHtmlSelected.style.color ? this.elementHtmlSelected.style.color : 'rgba(0,0,0,1)';
    this.fontProperty.content = this.elementHtmlSelected.innerText;
    if (this.elementHtmlSelected && (type === 'th' || type === 'td')) {
      this.fontProperty.indexColumn = indexColumn;
      this.fontProperty.indexCell = indexCell;
      this.fontProperty.indexRow = indexRow;
    }
    this.fontProperty.backgroundColor = this.elementHtmlSelected.style.backgroundColor ? this.elementHtmlSelected.style.backgroundColor : 'rgba(0,0,0,0)';
    this.selectFontItem = true;
    this.elementSelected = elementCopy;
  }

  // Se obtiene estilos del elemento HTML luego se establece en la clase tableProperty
  addTableProperty(elementSelected: any, index: number) {
    this.selectFontItem = false;
    this.selectImageItem = false;
    this.tableProperty = new TableProperty();
    this.elementHtmlSelected = this.getElementBy(index, ElementHtml.TABLE);
    if (this.elementHtmlSelected) {
      this.elementHtmlSelected.style.minWidth = '220px';
      this.elementHtmlSelected.style.marginBottom = '0px';
      this.elementHtmlSelected.style.width = elementSelected.tableProperty ? elementSelected.tableProperty.width : (this.elementHtmlSelected.style.width ? this.elementHtmlSelected.style.width : this.width);
      this.elementHtmlSelected.style.height = elementSelected.tableProperty ? elementSelected.tableProperty.height : (this.elementHtmlSelected.style.height ? this.elementHtmlSelected.style.height : this.height);
      this.elementHtmlSelected.style.lineHeight = elementSelected.tableProperty ? elementSelected.tableProperty.lineHeight : (this.elementHtmlSelected.style.lineHeight ? this.elementHtmlSelected.style.lineHeight : 'auto');
      this.tableProperty.width = this.elementHtmlSelected.style.width;
      this.tableProperty.height = this.elementHtmlSelected.style.height;
      this.tableProperty.lineHeight = this.elementHtmlSelected.style.lineHeight ? this.elementHtmlSelected.style.lineHeight : 'auto';
      this.elementSelected = elementSelected;
    }
    this.selectTableItem = true;
  }

  // Se obtiene estilos del elemento HTML luego se establece en la clase imageProperty
  addImageProperties(elementSelected: any, index: number, elementType: string) {
    this.selectFontItem = false;
    this.selectTableItem = false;
    console.log('Open image Properties');
    this.imageProperty = new ImageProperty();
    this.elementHtmlSelected = this.getElementBy(index, elementType);
    this.elementHtmlSelected.style.width = this.elementHtmlSelected.style.width ? this.elementHtmlSelected.style.width : '120px';
    this.elementHtmlSelected.style.height = this.elementHtmlSelected.style.height ? this.elementHtmlSelected.style.height : '100px';
    this.imageProperty.fileName = this.elementHtmlSelected.getAttribute('alt') ? this.elementHtmlSelected.getAttribute('alt') : 'Seleccione...';
    this.imageProperty.width = this.elementHtmlSelected.style.width;
    this.imageProperty.height = this.elementHtmlSelected.style.height;
    this.imageProperty.src = elementSelected.imageProperty ? elementSelected.imageProperty.src : this.elementHtmlSelected.getAttribute('src');
    this.elementHtmlSelected.setAttribute('src', this.elementHtmlSelected.getAttribute('src'));
    this.elementSelected = elementSelected;
    this.selectImageItem = true;
  }

  // Los estilos aplicados en la clase imageProperty se setea al elemento HTML seleccionado.
  applyImageProperty(imageProperty: any, option?: any) {
    if (imageProperty) {
      this.imageProperty = imageProperty;
      this.elementHtmlSelected.style.width = imageProperty.width;
      this.elementHtmlSelected.style.height = imageProperty.height;
      this.elementHtmlSelected.setAttribute('src', imageProperty.src);
      this.elementHtmlSelected.setAttribute('alt', imageProperty.fileName);
      this.elementHtmlSelected.imageProperty = this.imageProperty;
      if (!option) {
        this.elementSelected.imageProperty = this.imageProperty;
      }
    }
  }

  // Los estilos aplicados en la clase fontProperty se setea al elemento HTML seleccionado.
  applyFontProperty(fontProperty: any) {
    if (fontProperty) {
      if (this.elementSelected.type === (ElementHtml.TYPE_TEXT || ElementHtml.TYPE_PARAM)) {
        this.deleteParam(this.elementSelected.text);
      }
      this.elementHtmlSelected.style.fontFamily = fontProperty.fontFamily;
      this.elementHtmlSelected.style.textDecoration = fontProperty.textDecoration;
      this.elementHtmlSelected.style.color = fontProperty.color;
      this.elementHtmlSelected.innerText = fontProperty.content;
      this.elementHtmlSelected.style.lineHeight = '1.2';
      this.elementHtmlSelected.style.maxWidth = '572px';
      this.elementHtmlSelected.style.backgroundColor = fontProperty.backgroundColor;
      this.elementHtmlSelected.style.borderRadius = fontProperty.borderRadius;
      this.elementHtmlSelected.style.fontWeight = fontProperty.fontWeight;
      this.elementHtmlSelected.style.textAlign = fontProperty.textAlign;
      this.elementSelected.text = fontProperty.content;
      this.elementSelected.fontProperty = this.fontProperty;
      const index = this.fontProperty.indexElement;
      if (this.elementSelected.type === ElementHtml.TYPE_TABLE) {
        if (ElementHtml.TD === this.fontProperty.elementType) {
          const indexRow = this.fontProperty.indexRow;
          const indexCell = this.fontProperty.indexCell;
          this.elementSelected.rows[indexRow].cells[indexCell].cellName = this.fontProperty.content;
          this.deleteParam(this.elementSelected.rows[indexRow].cells[indexCell].cellName);
        } else {
          console.log('Column editor');
          const indexColumn = this.fontProperty.indexColumn;
          this.elementSelected.columns[indexColumn].colName = this.fontProperty.content;
          this.deleteParam(this.elementSelected.columns[indexColumn].colName);
        }
      }
      this.elements[index] = this.elementSelected;
      this.setParameters(fontProperty.content);
      return this.elementHtmlSelected.style.fontSize = fontProperty.fontSize;
    } else {
      return this.elementHtmlSelected.style.fontSize = '12px';
    }
  }

  // Los estilos aplicados en la clase tableProperty se setea al elemento HTML seleccionado.
  applyTableProperty(tableProperty: any) {
    if (tableProperty) {
      this.tableProperty = tableProperty;
      this.elementHtmlSelected.style.width = tableProperty.width;
      this.elementHtmlSelected.style.height = tableProperty.height;
      this.elementHtmlSelected.style.lineHeight = tableProperty.lineHeight ? tableProperty.lineHeight : 'auto';
      this.elementSelected.tableProperty = this.tableProperty;
    }
  }

  // Se setea la imagen en <img> del element HTML.
  setImageSrc(elementSelected: any, elementType: string, index: number) {
    if (elementSelected.imageProperty.src) {
      const element = this.getElementBy(index, elementType);
      if (element) {
        element.setAttribute('src', elementSelected.imageProperty.src);
      }
    }
  }

  delete() {
    this.columns = [];
    this.elements.splice(this.index, 1);
  }

  selectedItem(content: string) {
    this.content = content;
  }

  // En este metodo se agrega nuevos elementos a al contenedor pdfContainer.
  addElement(elementType: number, description: any, index?: number) {
    const newElement = new Element();
    this.index = index;

    const fontProperty = this.loadInitialDataFontProperty();
    const imageProperty = new ImageProperty();
    this.elementType = Number(elementType);
    newElement.style = '';
    switch (this.elementType) {
      case ElementHtml.TYPE_TEXT:
        newElement.type = this.elementType;
        this.addTextElement(newElement, fontProperty, description);
        break;
      case ElementHtml.TYPE_PARAM:
        newElement.type = this.elementType;
        this.addParamElement(newElement, fontProperty, description);
        break;
      case ElementHtml.TYPE_TABLE:
        this.clearTableElements();
        this.addTableElement(newElement, fontProperty);
        break;
      case ElementHtml.TYPE_IMG:
        newElement.type = this.elementType;
        this.addImageElement(newElement, imageProperty, index);
        break;
      case ElementHtml.TYPE_LINE:
        newElement.type = this.elementType;
        newElement.text = ElementHtml.HR;
        this.elements.push(newElement);
        break;
      default:
    }
  }

  // Este metodo permite agregar filas a la tabla
  addRow(elementSelected: any) {
    const cells: any[] = [];
    // tslint:disable-next-line:prefer-for-of
    for (let indexCol = 0; indexCol < elementSelected.columns.length; indexCol++) {
      const cell = {cellName: 'Cell'.concat(String(elementSelected.rows.length - 1).concat(String(indexCol)))};
      cells.push(cell);
    }
    const row = {rowItem: elementSelected.rows.length + 1, cells};
    elementSelected.rows.push(row);
  }

  // Este metodo permite agregar columnas a la tabla
  addColumn(elementSelected: any) {
    const column = {colName: 'Column' + (elementSelected.columns.length + 1)};
    // tslint:disable-next-line:prefer-for-of
    for (let indexRow = 0; indexRow < elementSelected.rows.length; indexRow++) {
      const cell = {cellName: 'Cell' + indexRow + elementSelected.columns.length + 1};
      elementSelected.rows[indexRow].cells.push(cell);
    }
    elementSelected.columns.push(column);
  }

  selectElement(index) {
    this.index = index;
  }

  deleteTable() {
    this.elementType = 0;
    return this.isAddTable;
  }

  deleteColumns(elementSelected: any, index: number) {
    // tslint:disable-next-line:prefer-for-of
    this.deleteCells(elementSelected);
    elementSelected.columns.splice(elementSelected.columns.length - 1, 1);
    this.elements[index] = elementSelected;
  }

  deleteRows(elementSelected: any) {
    const rowIndex = elementSelected.rows.length - 1;
    elementSelected.rows.splice(rowIndex, 1);
  }

  // En este metodo se evalua el tipo de elemento seleccionado luego se muestra las propiedades a editar.
  addProperties(elementSelected: any, index: number, elementType?: string) {
    elementSelected.type === ElementHtml.TYPE_IMG ? this.addImageProperties(elementSelected, index, ElementHtml.IMAGE)
      : (elementType === ElementHtml.TABLE ? this.addTableProperty(elementSelected, index)
        : this.addFontProperties(elementSelected, index, ElementHtml.NONE));
  }

  // tslint:disable-next-line:no-shadowed-variable
  setInitialRowOnTable(element: any) {
    const row = new Row();
    row.rowItem = 1;
    this.rows.push(row);
    return element.rows = this.rows;
  }

  // tslint:disable-next-line:no-shadowed-variable
  setInitialColumnOnTable(element: any) {
    this.columns = [];
    this.rows = [];
    const column = new Column();
    const row = new Row();
    column.colName = 'Column1';
    this.columns.push(column);
    this.rows.push(row);
    element.columns = this.columns;
    return element.rows = this.rows;
  }

  private setInitialData() {
    if (this.isNewTemplate) {
      this.template.partnerId = this.partnerIdSelected;
      this.template.enterpriseId = this.enterpriseIdSelected;
    }
    this.template.content = JSON.stringify(this.elements);
    const moreAboutTemplate = new MoreAboutTemplate();
    moreAboutTemplate.base64 = LocalStorage.getFileBase64();
    moreAboutTemplate.parameters = JSON.stringify(this.parameters);
    this.template.moreAboutTemplate = moreAboutTemplate;
  }

  private register() {
    this.loading = true;
    this.saveFileOnLocalStorage().then(() => {
      setTimeout(() => {
        this.setInitialData();
        this.templateService.save(this.template).subscribe((next: any) => {
          this.loading = false;
          if (next) {
            this.activeModal.close(InformType.Success);
          }
        }, error => {
          if (HttpStatusCode.METHOD_FAILURE === error.status) {
            Dialog.show(InformType.Warning, this.translate.instant('TITLE.TEMPLATES'), error.error.message);
            this.activeModal.close(InformType.Anything);
          }
          this.loading = false;
          this.activeModal.close(InformType.Danger);
        });
      }, 2500);
    });
  }

  private edit() {
    this.loading = true;
    this.saveFileOnLocalStorage().then(() => {
      setTimeout(() => {
        this.setInitialData();
        // this.template.content = JSON.stringify(this.elements);
        this.templateService.edit(this.template).subscribe((next: any) => {
          this.loading = false;
          if (next) {
            this.activeModal.close(InformType.Success);
          }
        }, error => {
          if (HttpStatusCode.METHOD_FAILURE === error.status) {
            Dialog.show(InformType.Warning, this.translate.instant('TITLE.TEMPLATES'), error.error.message);
            this.activeModal.close(InformType.Anything);
          }
          this.loading = false;
          this.activeModal.close(InformType.Danger);
        });
      }, 2000);
    });
  }

  private loadDataTemplate() {
    this.elements = [];
    if (this.isNewTemplate) {
      // setTimeout(() => {
      this.elements = this.templateService.getElementByDefault();
      // }, 100);
    } else if (this.designTemplate) {
      setTimeout(() => {
        this.elements = JSON.parse(this.template.content);
        this.showAll = this.template.showAll;
      }, 100);
      setTimeout(() => {
        for (let index = 0; index < this.elements.length; index++) {
          if (this.elements[index].type === ElementHtml.TYPE_IMG) {
            this.elementHtmlSelected = this.getElementBy(index, ElementHtml.IMAGE);
            this.elementHtmlSelected.style.width = this.elements[index].imageProperty.width;
            this.elementHtmlSelected.style.height = this.elements[index].imageProperty.height;
            this.elementHtmlSelected.setAttribute('src', this.elements[index].imageProperty.src);
          } else if (this.elements[index].type === ElementHtml.TYPE_TABLE) {
            this.elementHtmlSelected = this.getElementBy(index, ElementHtml.TABLE);
            // tslint:disable-next-line:no-unused-expression
            this.elementHtmlSelected ? this.addProperties(this.elements[index], index, ElementHtml.TABLE) : this.elementHtmlSelected;
            this.elementHtmlSelected.style.color = this.elements[index].fontProperty.color;
            this.elementHtmlSelected.style.textAlign = this.elements[index].fontProperty.textAlign;
            this.elementHtmlSelected.style.backgroundColor = this.elements[index].fontProperty.backgroundColor;
          } else {
            this.elementHtmlSelected = this.getElementBy(index, ElementHtml.TEXT);
            this.elementHtmlSelected.style.color = this.elements[index].fontProperty.color;
            this.elementHtmlSelected.style.backgroundColor = this.elements[index].fontProperty.backgroundColor;
            this.elementHtmlSelected.style.borderRadius = this.elements[index].fontProperty.borderRadius;
            this.elementHtmlSelected.style.fontFamily = this.elements[index].fontProperty.fontFamily;
            this.elementHtmlSelected.style.fontWeight = this.elements[index].fontProperty.fontWeight;
            this.elementHtmlSelected.style.textDecoration = this.elements[index].fontProperty.textDecoration;
            this.elementHtmlSelected.style.textAlign = this.elements[index].fontProperty.textAlign;
          }
        }
        const parametersDb = this.template._more.parameters;
        if (parametersDb !== undefined) {
          this.parameters = JSON.parse(parametersDb);
        }
      }, 500);
    }
  }

  // Este metodo convierte HTML a PDF luego se visualiza.
  preview(type?: string) {
    this.saveFileOnLocalStorage().then(() => {
      const openPreviewModal = this.modalService.open(PreviewTemplateComponent, {
        backdrop: 'static',
        size: 'lg'
      });
      openPreviewModal.componentInstance.type = type;
    });
  }

  // En este metódo convierte HTML a PDF y guarda en sessión storage en base64 de manera temporal
  async saveFileOnLocalStorage(): Promise<any> {
    const DATA: any = document.getElementById('pdfContainer');
    const options = {
      background: 'white',
      scale: 4
    };
    await html2canvas(DATA, options);
    const PDF = new jsPDF('p', 'pt', 'letter');
    PDF.setFontSize(12);
    this.elementHtmlSelected = document.querySelector('#pdfContainer');
    this.jsPDF.html(this.elementHtmlSelected, {
      callback(element) {
        const blob: any = element.output('datauristring');
        const base64 = blob.split('base64,');
        // Se guarda en session storage la URL del Pdf a visualizar
        SessionStorage.saveUrlPdf(base64[1]);
        // Se guarda en session storage pdf en base64
        SessionStorage.saveBase64(base64[1]);
        return;
      },
      x: 10,
      y: 10,
    });
  }

  // Este metodo permite cargar y registrar la plantilla PDF.
  upload() {
    this.isNewTemplate ? this.uploadAndRegister() : this.uploadAndEdit();
  }

  uploadAndRegister() {
    if (this.templateForm.invalid && !this.selectedFile) {
      return;
    }
    const formData = new FormData();
    formData.append('partnerId', String(this.partnerIdSelected));
    formData.append('enterpriseId', String(this.enterpriseIdSelected));
    formData.append('type', String(this.template.type));
    formData.append('description', String(this.template.description));
    formData.append('file', this.selectedFile, this.selectedFile.name);
    this.templateService.uploadTo(formData).subscribe((event: HttpEvent<any>) => {
      this.uploading = true;
      switch (event.type) {
        case HttpEventType.Sent:
          // TODO When request has been made
          break;
        case HttpEventType.ResponseHeader:
          // TODO When response header has been received
          break;
        case HttpEventType.UploadProgress:
          this.progressUpdate = Math.round(event.loaded / event.total * 100);
          break;
        case HttpEventType.Response:
          this.uploading = false;
          this.activeModal.close(InformType.Success);
          break;
      }
    }, () => {
      this.progressUpdate = 0;
    });
  }

  private uploadAndEdit() {
    if (this.templateForm.invalid && !this.selectedFile) {
      return;
    }
    const formData = new FormData();
    formData.append('templateId', String(this.template.id));
    formData.append('description', String(this.template.description));
    formData.append('file', this.selectedFile, this.selectedFile.name);
    this.templateService.uploadToEdit(formData).subscribe((event: HttpEvent<any>) => {
      this.uploading = true;
      switch (event.type) {
        case HttpEventType.Sent:
          // TODO When request has been made
          break;
        case HttpEventType.ResponseHeader:
          // TODO When response header has been received
          break;
        case HttpEventType.UploadProgress:
          this.progressUpdate = Math.round(event.loaded / event.total * 100);
          break;
        case HttpEventType.Response:
          this.uploading = false;
          this.activeModal.close(InformType.Success);
          break;
      }
    }, () => {
      this.progressUpdate = 0;
      // this.processError(this.title, error);
    });
  }

  // Este metodo elimina celdas.
  deleteCells(elementSelected: any) {
    const indexCell = elementSelected.rows[elementSelected.rows.length - 1].cells - 1;
    // tslint:disable-next-line:prefer-for-of
    for (let indexRow = 0; indexRow < elementSelected.rows.length; indexRow++) {
      elementSelected.rows[indexRow].cells.splice(indexCell, 1);
      console.log(indexCell);
    }
  }

  // Obtenemos la ultima posición del elemento cuando se suelta en el contenedor.
  dragEnded(event: CdkDragEnd, element: any) {
    element.style = 'transform:' + event.source.element.nativeElement.style.transform;
  }

  // tslint:disable-next-line:no-shadowed-variable
  getStyleForTag(elementSelected: any) {
    if (elementSelected.fontProperty) {
      return 'font-size:' + elementSelected.fontProperty.fontSize +
        ';width:' + elementSelected.fontProperty.width +
        ';height:' + elementSelected.fontProperty.height +
        ';color:' + elementSelected.fontProperty.color +
        ';font-weight:' + elementSelected.fontProperty.fontWeight +
        ';line-height:' + elementSelected.fontProperty.lineHeight + ';';
    }
    return '';
  }

  deleteItem(index: number) {
    this.deleteParam(this.elements[index].text);
    this.elements.splice(index, 1);
    this.selectImageItem = false;
    this.selectFontItem = false;
    this.selectTableItem = false;
  }

  private clearTableElements() {
    this.rows = [];
    this.cells = [];
    this.columns = [];
  }

  private createForm() {
    this.templateForm = this.formBuilder.group({
      description: [null, [Validators.required]],
      file: [null],
    });
  }

  private addTextElement(newElement: Element, fontProperty, description) {
    newElement.type = this.elementType;
    newElement.text = description;
    newElement.fontProperty = fontProperty;
    this.elements.push(newElement);
  }

  private addParamElement(newElement: Element, fontProperty: any, description: any) {
    newElement.text = 'p_' + description.trimRight();
    newElement.fontProperty = fontProperty;
    this.setParameters('p_' + description.trimRight());
    this.elements.push(newElement);
  }

  private addTableElement(newElement: Element, fontProperty: any) {
    this.isAddTable = true;
    newElement.type = this.elementType;
    const row = new Row();
    const column = new Column();
    column.colName = 'Column1';
    const cell = new Cell();
    cell.cellName = 'Cell';
    this.cells.push(cell);
    row.cells = this.cells;
    row.rowItem = 1;
    this.columns.push(column);
    this.rows.push(row);
    newElement.rows = this.rows;
    newElement.columns = this.columns;
    newElement.fontProperty = fontProperty;
    newElement.text = '';
    this.elements.push(newElement);
  }

  private addImageElement(newElement: Element, imageProperty: ImageProperty, index: number) {
    newElement.imageProperty = imageProperty;
    newElement.text = ElementHtml.getImgElementBy(index);
    this.elements.push(newElement);
  }

  loadInitialDataFontProperty() {
    return new FontProperty();
  }

  // En este metodo se obtiene el elemente HTML seleccionado por etiqueta.
  getElementBy(index: number, elementType: string, indexColumn?: number, indexRow?: number, indexCell?: number) {
    switch (elementType) {
      case ElementHtml.TH:
        return document.getElementById(ElementHtml.TH.concat(String(index).concat(String(indexColumn))));
      case ElementHtml.TD:
        return document.getElementById(ElementHtml.TD.concat(String(index)).concat(String(indexRow)).concat(String(indexCell)));
      case ElementHtml.IMAGE:
        const htmlElement = document.getElementById(ElementHtml.TEXT.concat(String(index)));
        if (htmlElement != null) {
          return htmlElement.getElementsByTagName(ElementHtml.IMG)[Constant.ZERO_INDEX];
        }
        return;
      case ElementHtml._HR:
        return document.getElementsByTagName(ElementHtml._HR)[Constant.ZERO_INDEX];
      case ElementHtml.TABLE:
        return document.getElementById(ElementHtml.TABLE.concat(String(index)));
      default:
        return document.getElementById(ElementHtml.TEXT.concat(String(index)));
    }
  }

  isInvalidControl(ctrlName: string) {
    return this.templateForm.get(ctrlName).invalid && this.templateForm.get(ctrlName).touched;
  }

  // Se obtiene el elemento img luego se setea estilos iniciales como width y height
  getStyleTransform(elementSelected: any, index) {
    if (elementSelected.type === 4) {
      const elementById = document.getElementById('text' + index);
      if (elementById) {
        const imgBox = elementById.getElementsByTagName('img')[0];
        imgBox.style.width = elementSelected.imageProperty.width;
        imgBox.style.height = elementSelected.imageProperty.height;
      }
    }
    return elementSelected.style;
  }

  changeStatus(event: any) {
    this.selectedFile = (event.target as HTMLInputElement).files[0];
  }

  private getDefaultData() {
    if (!this.isNewTemplate) {
      this.partnerIdSelected = this.template.partnerId ? this.template.partnerId : 0;
      this.enterprises = this.getEnterprise(this.partnerIdSelected);
      this.enterpriseIdSelected = this.enterprises.find(enterprise => enterprise.id === this.template.enterpriseId).id;
    }
  }

  reloadEnterprise(partnerId: any) {
    // this.enterprises = LocalStorage.getEnterprisesExtraBy(partnerId);
    this.enterprises = this.getEnterprise(partnerId);
    this.enterpriseIdSelected = this.enterprises[Constant.ZERO_INDEX].id;
  }

  viewParams(): void {
    const message = this.translate.instant('MESSAGE.FORMANT-PARAM-ALLOWED-TEMPLATE-DESIGN')
      .concat('<ul>')
      .concat('<li style="text-align: justify;">')
      .concat(this.translate.instant('MESSAGE.PARAM-FORMAT-DESCRIPTION'))
      .concat('</li>')
      .concat('</ul>')
      .concat(this.translate.instant('MESSAGE.NOTE-PARAM-ALLOWED'));
    Dialog.show(InformType.Info, this.translate.instant('TITLE.PARAMETERS-ALLOWED-TO-TEMPLATE-DESIGN'), message);
  }

  private setDefaultData() {
    this.partnerIdSelected = LocalStorage.getPartnerId();
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      this.partners = LocalStorage.getPartners();
      this.partnerIdSelected = this.partners[Constant.ZERO_INDEX].id;
      this.enterprises = this.getEnterprise(this.partnerIdSelected);
      this.enterpriseIdSelected = this.enterprises[Constant.ZERO_INDEX].id;
    } else if (this.hasRole(this.ROLE_PARTNER)) {
      this.enterprises = this.getEnterprise( this.partnerIdSelected);
      this.enterpriseIdSelected = this.enterprises[Constant.ZERO_INDEX].id;
    } else {
      this.enterpriseIdSelected = this.authenticationService.getEnterpriseIdView();
    }
  }

  onlyShowAll(event: any) {
    this.showAll = event.target.checked;
    this.template.showAll = this.showAll;
  }

  hasRole(roleDescription: any) {
    return this.authenticationService.hasRole(roleDescription);
  }

  setParameters(content: any) {
    const parameters: any[] = content.match(/(\bp_\S+\b)/ig); // este patrón permite obtener palabras que tengan p_ ó P_
    // tslint:disable-next-line:prefer-for-of
    for (let index = 0; index < parameters.length; index++) {
      this.pushValue(parameters[index]);
    }
  }

  /*Verificamos que no existan parametros con el mismo nombre para ser agregado a la lista de parametros.*/
  pushValue(param: any) {
    const paramFounded = this.parameters.find(param1 => param1 === param) ? param : null;
    if (paramFounded === null) {
      // Seteamos parametros nuevos en la lista.
      this.parameters.push(param);
    }
  }


  /*obtiene el indice del parametro a eliminar*/
  deleteParam(textValue: any) {
    const parameters: any[] = textValue.match(/(\bp_\S+\b)/ig);
    if (parameters) {
      // tslint:disable-next-line:prefer-for-of
      for (let index = 0; index < parameters.length; index++) {
        const indexToDelete = this.parameters.indexOf(parameters[index]);
        if (indexToDelete > -1) {
          this.parameters.splice(indexToDelete, 1);
        }
      }
    }
  }

  reloadEnterprises() {
    this.enterprises = LocalStorage.getEnterprisesExtraBy(this.partnerIdSelected);
    this.enterpriseIdSelected = this.enterprises[Constant.ZERO_INDEX].id;
  }

  get isNewTemplate(): boolean {
    return this.template.id === undefined;
  }

  get isIofe() {
    return LocalStorage.getEnterpriseDocumentNumber() === Constant.RUC_IOFE;
  }

  private getEnterprise(partnerId: number) {
    // const enterprises1 = this.enterpriseDataService.getEnterprises().filter(value => partnerId === value.partnerId);
    return this.enterpriseDataService.getEnterprises().filter(value => partnerId === value.partnerId);
  }
}
